<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="">
        <el-button type="success" @click="search">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #type="{ row }">
        <div>
          {{ getNameByValue(coopType, row.manage_role) }}
        </div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="danger" v-if="row.status == 4">退款</el-tag>
          <el-tag type="success" v-if="row.status == 1">可用</el-tag>
          <el-tag type="info" v-if="row.status == 2">不可用</el-tag>
          <el-tag type="warning" v-if="row.status == 0">待支付</el-tag>
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button v-if="row.status == 1" type="primary" @click="openCoachUpdate(row)">设置</el-button>
          <el-button v-if="row.status == 1" type="danger" @click="delCoach(row)">删除</el-button>
        </div>
      </template>
    </auto-table>

    

     <el-dialog
      :visible.sync="updateShow"
      width="50%"
      title="合作门店设置"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item label="教练" >
          {{curItem.coachInfo ? curItem.coachInfo.name : ''}}
        </el-form-item>
       <el-form-item label="分成比例" >
         <el-input v-model="custom_guild_rate" placeholder="如0.2"></el-input>
        </el-form-item>
        <div>
          扣除平台服务费后，教练到手的比例，剩余的费用为公会收益
        </div>
        <el-form-item label="主管教练" >
            {{manager_name || ''}}
          <userSelect @change="changeUser"></userSelect> 
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="updateShow = false">取 消</el-button>
        <el-button  type="primary" @click="updateCoachInfo()"
          >修 改</el-button
        >
      </span>
    </el-dialog>


    <bindEdit @success="search" ref="edit"></bindEdit>
    <settingRatio ref="ratioRef"></settingRatio>
  </div>
</template>

<script>
import bindEdit from './bindEdit.vue';
import userSelect from "@/components/select/userSelect.vue";
export default {
  components: {
    bindEdit,
    userSelect
  },
  data() {
    return {
      updateShow: false,
      curItem: {},
      DataList: [],
      Option: [
        { name: "教练", value: "coachInfo.name" },
        { name: "主管", value: "currentManager.nick_name"},
        { name: "教练到手比例", value: "custom_guild_rate"},
        { name: "时间", value: "join_date" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      type: "",
      guild_id: "",
      show: false,
      editForm: {},
      custom_guild_rate: '',
      manager_name: ''
    };
  },
  mounted() {
    this.guild_id = this.$route.query.id;
  },

  methods: {
    openCoachUpdate(v){
        this.curItem = v
        this.custom_guild_rate = v.custom_guild_rate
        this.manager_name = v.currentManager.nick_name
        this.updateShow = true
    },
    changeUser(v){
        this.managerUser = v
    },
    search(){
        this.getList(1);
    },
    load() {
      if (this.guild_id && this.DataList.length == 0) {
        this.getList(1);
      }
    },
    delCoach(row) {
      this.$confirm("确认取消与公会的合作？").then((res) => {
        this.$get("/user/coachGuildRelations/delete", { id: row.id }).then((res) => {
          this.search();
        });
      });
    },
    add() {
      this.$refs.edit.open();
    },
    updateCoachInfo(){
      let data = {
        id: this.curItem.id,
        custom_guild_rate: this.custom_guild_rate,
       
      }
      if(this.managerUser){
        data.current_manager_id= this.managerUser.user_id
      }

      this.$post('/user/coachGuildRelations/update',data).then((res) => {
        this.updateShow = false
          this.getList(1);
        });
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/coachGuildRelations/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          guild_id: this.guild_id
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.time_edit{
  color: rgb(78, 151, 235);
}
</style>